export default __webpack_public_path__ + "static/info-aa9517bf7644af10ab2a9c46740de67a.jpg";